export default __webpack_public_path__ + "static/media/Gloves of the Shivering Stars.dbdbb14e.jpg";